<template>
	<div>
		<draggable
			:value="value"
			tag="ul"
			ghost-class="is-placeholder-item"
			class="category-list"
			@input="handleKeyOrder"
		>
			<li
				v-for="categoryKey in value"
				:key="categoryKey.id"
				class="category-list-item"
			>
				<div>
					<!-- Display section -->
					<div class="d-flex flex-grow-1 align-items-center">
						<div class="flex-grow-1">
							<BannerProductCategoryItem
								:ref="`itemEn-${categoryKey.id}`"
								title="EN"
								:default-name="categoryKey.nameEn"
								:slide-banner-name="categoryKey.slideBannerNameEn"
								:is-editing="isEditing(categoryKey.id)"
								@cancel="handleCancel(categoryKey.id)"
								@confirm="handleConfirm(categoryKey.id)"
							/>
							<BannerProductCategoryItem
								:ref="`itemTh-${categoryKey.id}`"
								title="TH"
								class="mt-1"
								:default-name="categoryKey.nameTh"
								:slide-banner-name="categoryKey.slideBannerNameTh"
								:is-editing="isEditing(categoryKey.id)"
								@cancel="handleCancel(categoryKey.id)"
								@confirm="handleConfirm(categoryKey.id)"
							/>
						</div>
						<CIcon
							v-if="!isEditing(categoryKey.id)"
							class="icon-pencil ml-2"
							name="cil-pencil"
							@click.native="handleEdit(categoryKey.id)"
						/>
					</div>

					<!-- Button Section -->
					<div
						v-if="isEditing(categoryKey.id)"
						class="btn-icon-round-group mt-2"
					>
						<CButton
							color="success"
							class="btn-icon-round"
							@click="handleConfirm(categoryKey.id)"
						>
							<CIcon
								name="cil-check"
								class="text-white"
							/>
						</CButton>
						<CButton
							color="tertiary"
							class="btn-icon-round"
							@click="handleCancel(categoryKey.id)"
						>
							<CIcon name="cil-x" />
						</CButton>
					</div>
				</div>
			</li>
		</draggable>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import BannerProductCategoryItem from '@/components/BannerProductCategoryItem.vue';

export default {
	name: 'CategoryDraggable',

	components: {
		draggable,
		BannerProductCategoryItem,
	},
	props: {
		value: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			keys: this.value,
			editingSet: new Set(),
		};
	},
	methods: {
		handleKeyOrder(sortedKey) {
			this.$emit('input', sortedKey);
		},
		handleEdit(id) {
			this.editingSet = new Set(this.editingSet).add(id);
		},
		handleCancel(id) {
			this.editingSet = new Set(this.editingSet);
			this.editingSet.delete(id);
		},
		handleConfirm(id) {
			const [itemEn] = this.$refs[`itemEn-${id}`];
			const [itemTh] = this.$refs[`itemTh-${id}`];

			const updatedValue = this.value.map((categoryKey) => {
				if (categoryKey.id !== id) {
					return categoryKey;
				}

				return {
					...categoryKey,
					slideBannerNameEn: itemEn.input,
					slideBannerNameTh: itemTh.input,
				};
			});

			this.keys = updatedValue;

			this.editingSet = new Set(this.editingSet);
			this.editingSet.delete(id);

			this.$emit('input', updatedValue);
		},
		isEditing(id) {
			return this.editingSet.has(id);
		},
	},
};
</script>

<style lang="scss" scoped>
	.icon-trash {
		color: $color-black-25;
	}

	.icon-pencil {
		cursor: pointer;
	}

	.btn-icon-round-group {
		display: flex;
		gap: rem(8);
		justify-self: end;
	}

	.btn-icon-round {
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(28);
		height: rem(28);
		padding: 0;
		border-radius: 8px;
	}

	.category-list {
		min-height: rem(36);
		border-radius: 4px;
		background-color: $color-gray-100;
		list-style-type: none;
		padding: 2px;
		margin: 0;

		// .category-list-item
		&-item {
			position: relative;
			z-index: 1;
			padding: rem(6) rem(12);
			background-color: $color-white;
			cursor: move;
			border-radius: 4px;
			transition: $transition-duration background-color;
			margin-bottom: 2px;

			&:last-child {
				margin-bottom: 0;
			}

			&.is-placeholder-item {
				opacity: 0.5;
			}
		}
	}
</style>
